module.exports = __webpack_public_path__ + "img/公益课堂.02669770.png";